import { Injectable, ApplicationRef, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { filter, first, interval } from 'rxjs';
import { ConfirmDialogService } from './confirm-dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class SwUpdateService {
  private appRef = inject(ApplicationRef);
  private swUpdate = inject(SwUpdate, { optional: true });
  private confirmService = inject(ConfirmDialogService);
  private translate = inject(TranslateService);

  checkForUpdates(): void {
    const swUpdate = this.swUpdate;
    if (!swUpdate?.isEnabled) return;

    // 🔑 Wait until app is stable (CRITICAL for SSR)
    this.appRef.isStable.pipe(first(stable => stable)).subscribe(() => {
      // Periodic check
      interval(15 * 1000).subscribe(() => {
        swUpdate.checkForUpdate();
      });

      // Listen for updates
      swUpdate.versionUpdates
        .pipe(filter(e => e.type === 'VERSION_READY'))
        .subscribe(() => this.promptUser());
    });
  }

  private async promptUser(): Promise<void> {
    const swUpdate = this.swUpdate;
    if (!swUpdate) return;

    const accepted = await this.confirmService.updateVersionConfirmationDialog(
      ' ',
      this.translate.instant('updateVersionBild')
    );

    if (accepted) {
      await swUpdate.activateUpdate(); // 🔥 REQUIRED in SSR
      document.location.reload();
    }
  }
}
